'use client';

import {
  Fragment,
  ReactNode,
  useState,
  cloneElement,
  isValidElement,
  ReactElement,
  HTMLAttributes,
} from 'react';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { ClassNameProps } from '@/types/common.types';

import { PromoCodeResult } from '@/api/types/user.types';

import { logAnalyticsEvent } from '@/libs/firebase/log-analytics-event';

import { FirebaseEventNameEnum } from '@/enums/firebase-event-name.enums';

import { Modal } from '@/components/Modal';
import { PromoCodeFormView } from '@/components/PromoCodeModal/PromoCodeForm';
import styles from '@/components/PromoCodeModal/PromoCodeModal.module.scss';
import { SuccessPromoCodeContainer } from '@/components/PromoCodeModal/SuccessPromoCodeContainer';

// =================================================================

export const PromoCodeModal = (
  props: Partial<ClassNameProps> & { children?: ReactElement; icon?: ReactNode },
) => {
  const { className, icon, children } = props;

  const t = useTranslations('layout');

  const [open, setOpen] = useState<boolean>(false);
  const [openAlertModal, setOpenAlertModal] = useState<boolean>(false);
  const [promoCodeResponse, setPromoCodeResponse] = useState<PromoCodeResult[]>([]);

  const handleCloseAlertModal = () => setOpenAlertModal(false);

  const handleOpenAlertModal = (promoCodeDate: PromoCodeResult[]) => {
    onClose();
    setPromoCodeResponse(promoCodeDate);
    setOpenAlertModal(true);
  };

  const onClose = () => setOpen(false);

  const onOpen = () => {
    setOpen(true);
    logAnalyticsEvent(FirebaseEventNameEnum.CLICK, {
      title: 'promo-code-modal',
    });
  };

  return (
    <Fragment>
      {children ? (
        isValidElement(children) ? (
          cloneElement(children, { onClick: onOpen } as HTMLAttributes<HTMLElement>)
        ) : (
          children
        )
      ) : (
        <button title="Promocode" className={clsx(styles.navLink, className)} onClick={onOpen}>
          {icon}
          {t('header.navigation.promocode')}
        </button>
      )}

      <Modal size="sm" isOpen={open} onClose={onClose} className={styles.modalCenterInMobile}>
        <Modal.Header onClose={onClose}>{t('header.navigation.promocode')}</Modal.Header>
        <Modal.Body>
          <PromoCodeFormView handleOnSuccessFn={handleOpenAlertModal} isModalVariant />
        </Modal.Body>
      </Modal>

      <Modal
        isOpen={openAlertModal}
        size="sm"
        onClose={handleCloseAlertModal}
        className={styles.alertModal}
      >
        <Modal.Header onClose={handleCloseAlertModal} />
        <Modal.Body>
          <SuccessPromoCodeContainer promoCodeResponse={promoCodeResponse} />
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};
